module.exports = __webpack_public_path__ + "static/media/transfer.dd4cd673.png";